export default __webpack_public_path__ + "static/media/1966.356da971.jpg";